import { faqServices } from "../services/faqServices";

export const faqActions = {
    hospitalFaq
}

function hospitalFaq(dispatch, intl) {
    dispatch(request());

    faqServices.getFaq(intl)
        .then(
            res=> {
                dispatch(success(res))
            },
            error=> {
                dispatch(failure(error))
            }
        );

    function request() { return { type: "FAQ_REQUEST" } }
    function success(faq) { return { type: "FAQ_SUCCESS", faq } }
    function failure(error) { return { type: "FAQ_FAILURE", error } }

}